import type { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface CommentCountBadgeProps {
  count: number;
  children: ReactNode;
}

export const CommentCountBadge: FC<CommentCountBadgeProps> = ({ count, children }) => {
  if (count === 0) {
    return <>{children}</>;
  }

  const hasMoreThanNinetyNineComments = count > 99;

  return (
    <div className="relative inline-flex">
      {children}
      <div
        className={twMerge(
          'bg-primary-600 pointer-events-none absolute -top-1 -right-1.5 flex size-5 items-center justify-center rounded-full text-xs leading-5 font-medium text-white',
          hasMoreThanNinetyNineComments && '!text-[8px]',
        )}
        data-testid="comment-count-badge"
      >
        {hasMoreThanNinetyNineComments ? '99+' : count}
      </div>
    </div>
  );
};
